








// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, computed } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ChartEvolutionContainer from '@/components/charts/ChartEvolutionContainer.vue';
// Import plugins ----------------------------------------------------------------------------------
import i18n from '@/plugins/i18n';
// Import utils - ----------------------------------------------------------------------------------
import { useChart, EThemeColor } from '@/utils/charts.utils';
import { EUnitKey } from '@/utils/parameter-units.utils';
// Import types ------------------------------------------------------------------------------------
import type { TDataStandard } from '@/components/patient/PatientEvolution.vue';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ChartEvolutionImpactForce',
  components: {
    ChartEvolutionContainer
  },
  props: {
    manifest: {
      type: Array,
      required: true
    },
    impactForce: {
      type: Object
    },
    norms: {
      type: Object
    },
    exportation: {
      type: Boolean
    }
  },
  setup(properties) {
    const {
      evolutionChartStructure,
      getSideData,
      getSideDataVariations,
      getSerieItemStructure,
      getNormsStructure
    } = useChart();

    const title = 'commons.standards.impact-force';

    const impactForce: TDataStandard = computed(() => getSideData(properties.impactForce));

    const dataVariations = computed(() =>
      getSideDataVariations({ left: impactForce.value?.left.values, right: impactForce.value?.right.values })
    );

    const valid = computed(() => !!impactForce.value);

    const series = computed(() => {
      let data = [
        // Left
        getSerieItemStructure(
          'impact_force_left',
          `${i18n.t('commons.standards.impact-force')} (${(i18n.t('commons.standards.left') as string).slice(
            0,
            1
          )})`,
          impactForce.value?.left.values,
          EThemeColor.Chart1
        ),
        getSerieItemStructure(
          'impact_force_left',
          undefined,
          impactForce.value?.left.ranges,
          EThemeColor.Chart1,
          true
        ),
        // Right
        getSerieItemStructure(
          'impact_force_right',
          `${i18n.t('commons.standards.impact-force')} (${(i18n.t('commons.standards.right') as string).slice(
            0,
            1
          )})`,
          impactForce.value?.right.values,
          EThemeColor.Chart2
        ),
        getSerieItemStructure(
          'impact_force_right',
          undefined,
          impactForce.value?.right.ranges,
          EThemeColor.Chart2,
          true
        )
      ];
      // Have norms
      if (properties.norms)
        data.push(
          getNormsStructure('impact_force_norms', properties.norms as { min: number[]; max: number[] })
        );

      return data;
    });

    const chartOptions = computed(() => {
      return {
        ...evolutionChartStructure(title, properties.manifest, EUnitKey.KiloNewton, 1, {
          exportation: properties.exportation
        }),
        series: series.value
      };
    });

    return {
      title,
      dataVariations,
      chartOptions,
      valid
    };
  }
});
